export default __webpack_public_path__ + "static/media/forum_img_3.6b8f2048.svg";